const maxWidth = 12;
const spans = {
  fullwidth: maxWidth,
  halfwidth: maxWidth / 2,
  thirdwidth: maxWidth / 3,
  quarterwidth: maxWidth / 4,
  sixthwidth: maxWidth / 6
};
export default spans;
